// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"Error404_errorPage__UaaAa","header":"Error404_header__1i5sc","underlined":"Error404_underlined__BEYA9","pillButton":"Error404_pillButton__TsHAb"};